export const uuid4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const ran = Math.random() * 16 | 0; // tslint:disable-line no-bitwise
    const val = c === 'x' ? ran : (ran & 0x3 | 0x8); // tslint:disable-line no-bitwise
    return val.toString(16);
  });
};
